import sanityClient from '@sanity/client';

export const client = sanityClient({
  projectId: 're9bmgnj',
  dataset: process.env.REACT_APP_SANITY_DATASET ?? 'production',
  useCdn: true,
});
